import type { PageHelp } from '../network-help.data';

export const L10N_fa_g3: Record<string, PageHelp> = {
  'flights-search': {
    title: 'پروازها',
    tag: 'جست‌وجوی پرواز',
    tagline: 'قیف فروش برای رزرو پرواز از هر تأمین‌کننده‌ای که آژانس می‌تواند برای آن بلیت صادر کند.',
    business: {
      lead: 'پروازها جایی است که آژانس سفر یک مشتری را به بلیت تبدیل می‌کند. هر نتیجه در این صفحه قابل صدور است — یا بر پایه SIGN خودِ آژانس یا از طریق یک SIGN شریک که دسترسی به آن اعطا شده — بنابراین کرایه‌های نمایش‌داده‌شده همان‌هایی هستند که آژانس واقعاً می‌تواند بدون یک مرحله تأیید اضافی بفروشد.',
      points: [
        { title: 'یک جست‌وجو در چندین مجرا', desc: 'یک پرس‌وجوی واحد به هر منبع محتوایی که آژانس فعال دارد پخش می‌شود (SIGN خودی، SIGNهای امانی از طریق دسترسی شریک، خوراک‌های NDC/GDS) و نتایج در یک فهرست رتبه‌بندی‌شده بر اساس قیمت ادغام می‌شوند.' },
        { title: 'قیمت‌گذاری لایه‌ای همین‌جا اعمال می‌شود', desc: 'قیمت‌های نمایش‌داده‌شده از پیش شامل مارک‌آپ‌های Wholesale (مالک SIGN)، Distribution (کانال) و Retail (خودی) از موتور قیمت‌گذاری هستند — آنچه مشتری می‌بیند همان چیزی است که آژانس قصد دارد دریافت کند.' },
        { title: 'مسافرمحور، نه کرایه‌محور', desc: 'انواع مسافر (بزرگسال / کودک / نوزاد) و تاریخ‌های سفر هم قیمت و هم واجد شرایط بودن استرداد / تغییر رزرو در مراحل بعد را هدایت می‌کنند، پس فرم ورودی اهمیت دارد.' },
      ],
    },
    software: {
      lead: 'یک صفحه جست‌وجوی کرایه که به یک API واقعی موجودی متصل است، با نتایج گروه‌بندی‌شده بر اساس قیمت و SIGN صادرکننده.',
      points: [
        { title: 'پرس‌وجو را بسازید', desc: 'مبدأ، مقصد، تاریخ‌ها و تعداد مسافران جست‌وجو را هدایت می‌کنند؛ کلاس / خط هوایی / کابین را می‌توان پس از اولین مجموعه نتایج محدودتر کرد.' },
        { title: 'سطر نتایج را بخوانید', desc: 'هر سطر کرایه، خط هوایی، کابین و اینکه بلیت بر پایه کدام SIGN صادر خواهد شد را نشان می‌دهد — نشان سمت راست.' },
        { title: 'به سمت رزرو پیش بروید', desc: 'انتخاب یک کرایه جزئیات پیشنهاد را باز می‌کند؛ از آنجا جریان فرم مسافر / نقشه صندلی / پرداخت، رزرو را به یک سند رزرو کامل می‌کند.' },
      ],
    },
    flow: {
      lead: 'مسیر سرتاسری از یک درخواست مشتری تا یک بلیت صادرشده.',
      steps: [
        { title: 'سفر را وارد کنید', desc: 'مبدأ، مقصد، یک‌طرفه یا رفت‌وبرگشت، تاریخ‌های سفر و تعداد بزرگسال / کودک / نوزاد.' },
        { title: 'جست‌وجو را اجرا کنید', desc: 'نتایج به هر تأمین‌کننده فعال پخش شده و در یک فهرست رتبه‌بندی‌شده بر اساس قیمت ادغام می‌شوند.' },
        { title: 'فیلتر و رتبه‌بندی کنید', desc: 'با خط هوایی، کابین، توقف‌ها و زمان پرواز محدود کنید؛ SIGN صادرکننده روی هر سطر دیده می‌شود.' },
        { title: 'پیشنهاد را باز کنید', desc: 'جزئیات پیشنهاد قوانین کرایه، بار، سیاست استرداد و تغییر رزرو را نشان می‌دهد — پیش از تعهد آن‌ها را بخوانید.' },
        { title: 'مسافران را ثبت کنید', desc: 'برای هر مسافر فرم مسافر (نام، تاریخ تولد، مدرک، مسافر مکرر) را پر کنید؛ انتخابگر CRM از مشتریان ذخیره‌شده پیش‌پر می‌کند.' },
        { title: 'صندلی و افزودنی‌ها را انتخاب کنید', desc: 'انتخابگر نقشه صندلی و افزودنی‌های پولی (بار، وعده غذایی) افزودنی‌های اختیاری روی پیشنهاد هستند.' },
        { title: 'پرداخت و صدور', desc: 'پرداخت بر پایه کیف پول / خط اعتباری آژانس دریافت می‌شود؛ PNR رزرو شده و بلیت الکترونیکی صادر می‌گردد.' },
      ],
    },
    modes: {
      lead: 'یک پیشنهاد پرواز از طریق یکی از سه حالت تأمین اجرا می‌شود — نشان روی هر نتیجه به شما می‌گوید کدام را دریافت می‌کنید.',
      modes: [
        { name: 'Own SIGN', when: 'آژانس اعتبارنامه مستقیم BSP / GDS دارد', desc: 'بلیت آژانس بر پایه SIGN خودش صادر می‌شود. سهم کامل کمیسیون، سریع‌ترین صدور، نزدیک‌ترین حلقه پشتیبانی با خط هوایی.' },
        { name: 'Partner SIGN', when: 'آژانس از اعطای آژانس دیگری استفاده می‌کند', desc: 'بلیت بر پایه SIGNای صادر می‌شود که از طریق دسترسی شریک اعطا شده است. لایه Wholesale موتور قیمت‌گذاری مارک‌آپ مالک SIGN را می‌گیرد.' },
        { name: 'NDC / connected', when: 'برای آن خط هوایی رابطه BSP وجود ندارد', desc: 'کرایه از خوراک NDC یا تجمیع‌کننده می‌آید. قوانین ممکن است با محتوای GDS متفاوت باشد (استردادها توسط رابط مدیریت می‌شوند، نقشه صندلی ممکن است محدود باشد).' },
      ],
    },
    examples: [
      {
        title: 'یک رفت‌وبرگشت بیزنس DXB → LHR · ۲ بزرگسال · SIGN خودی',
        rows: [
          { label: 'کرایه پایه (به‌ازای هر مسافر) × ۲', value: '28,000,000' },
          { label: 'مالیات‌ها و YQ', value: '4,200,000' },
          { label: 'Wholesale MARKUP · قابل اعمال نیست (SIGN خودی)', value: '0' },
          { label: 'Retail MARKUP · +۵٪ از ناخالص', value: '+1,610,000', accent: 'success' },
          { label: 'مجموع مسافر', value: '33,810,000', strong: true },
        ],
        note: 'صدور با SIGN خودی به‌کلی لایه Wholesale را رد می‌کند — مالک SIGN همان فروشنده است، پس حاشیه فروش مجدد برای پرداخت وجود ندارد.',
      },
      {
        title: 'همان سفر · SIGN شریک امانی',
        rows: [
          { label: 'کرایه پایه + مالیات‌ها', value: '32,200,000' },
          { label: 'Wholesale MARKUP · +۴٪ (سهم شریک)', value: '+1,288,000', accent: 'info' },
          { label: 'Retail MARKUP · +۵٪ از ناخالص', value: '+1,674,400', accent: 'success' },
          { label: 'مجموع مسافر', value: '35,162,400', strong: true },
        ],
        note: 'لایه Wholesale بابت اعطای SIGN به آژانس شریک پرداخت می‌کند. سپس Retail بر پایه مجموع در حال اجرای جدید محاسبه می‌شود.',
      },
    ],
    related: ['hotels-search', 'markup', 'signs', 'partner-access'],
  },

  'hotels-search': {
    title: 'هتل‌ها',
    tag: 'جست‌وجوی هتل',
    tagline: 'جریان جست‌وجو و رزرو برای اقامت‌های هتلی در موجودی خودی و تأمین‌کنندگان متصل.',
    business: {
      lead: 'هتل‌ها به آژانس اجازه می‌دهد یک اقامت را بفروشد، چه اتاق از موجودی قراردادی خودِ آژانس بیاید، چه از موجودی یک شریک که از طریق اعطا به اشتراک گذاشته شده، یا از یک تأمین‌کننده خارجی متصل. دو حالت فروش کنار هم وجود دارند: آنی (اپراتور از پیش تأیید می‌کند) و درخواستی (اپراتور درخواست را نگه می‌دارد تا تأمین‌کننده تأیید کند)، و صفحه روشن می‌کند که کدام حالت برای هر نتیجه اعمال می‌شود.',
      points: [
        { title: 'تأمین خودی در برابر متصل', desc: 'اتاق‌های قراردادی خودی در ماژول اقامتگاه هتل پلتفرم قرار دارند؛ تأمین متصل از ارائه‌دهندگان خارجی می‌آید. موتور هر دو را در یک مجموعه نتایج ادغام می‌کند.' },
        { title: 'آنی یا درخواستی', desc: 'نتایج آنی در زمان رزرو تأیید می‌شوند؛ نتایج درخواستی نرخ‌گذاری و نگه داشته می‌شوند تا اپراتور (یا تأمین‌کننده) آن‌ها را بپذیرد — گردش‌کار از آن تصمیم منشعب می‌شود.' },
        { title: 'قیمت‌گذاری شبانه = قیمت‌گذاری لایه‌ای', desc: 'نرخ شبانه نمایش‌داده‌شده از پیش شامل لایه‌های Wholesale / Distribution / Retail موتور قیمت‌گذاری است؛ تخفیف‌های فراگیر هر شب (مثلاً بر اساس طول اقامت) نیز می‌توانند اعمال شوند.' },
      ],
    },
    software: {
      lead: 'یک صفحه جست‌وجوی مقصد با نتایج اتاق / طرح نرخ و یک تقسیم رزرو-اکنون / درخواست-رزرو.',
      points: [
        { title: 'جست‌وجو بر اساس مقصد + تاریخ‌ها', desc: 'شهر، ورود / خروج و اتاق‌ها جست‌وجوی اصلی را هدایت می‌کنند؛ فیلترها (رتبه ستاره، پذیرایی، زنجیره) نتایج را محدود می‌کنند.' },
        { title: 'نشان حالت را بخوانید', desc: 'هر کاشی اقامتگاه یک نشان آنی یا درخواستی دارد تا حالت فروش پیش از تعهد اپراتور دیده شود.' },
        { title: 'به رزرو یا درخواست ادامه دهید', desc: 'انتخاب یک اتاق برای حالت آنی به جریان فرم مهمان و پرداخت پیش می‌رود؛ برای درخواستی یک فرم درخواست باز می‌کند که تا تأیید اپراتور به یک رزرو در انتظار تبدیل می‌شود.' },
      ],
    },
    flow: {
      lead: 'از «هفته آینده یک اتاق در دبی می‌خواهم» تا یک رزرو تأییدشده (یا یک درخواست نگه‌داشته‌شده).',
      steps: [
        { title: 'اقامت را وارد کنید', desc: 'شهر مقصد، تاریخ‌های ورود / خروج، تعداد اتاق و تعداد مهمانان.' },
        { title: 'جست‌وجو را اجرا کنید', desc: 'نتایج اتاق‌های قراردادی خودی و خوراک‌های تأمین‌کننده متصل را در یک فهرست رتبه‌بندی‌شده بر اساس قیمت ترکیب می‌کنند.' },
        { title: 'اقامتگاه‌ها را فیلتر کنید', desc: 'با رتبه ستاره، نوع پذیرایی، زنجیره، فاصله تا مرکز و بازه قیمت محدود کنید؛ هر کاشی یک نشان آنی یا درخواستی نشان می‌دهد.' },
        { title: 'اقامتگاه را باز کنید', desc: 'انواع اتاق، طرح‌های نرخ، سیاست لغو، پذیرایی و موارد شامل همگی در صفحه جزئیات اقامتگاه هستند.' },
        { title: 'یک طرح نرخ انتخاب کنید', desc: 'انتخاب کنید کدام طرح نرخ رزرو شود (فقط اتاق، B&B، نیم‌پانسیون، غیرقابل‌استرداد) و قیمت شبانه حاصل.' },
        { title: 'ثبت مهمانان + پرداخت', desc: 'فرم مهمان + پرداخت برای آنی. برای درخواستی، درخواست را ثبت کنید — رزرو تا تأیید در انتظار نگه داشته می‌شود.' },
        { title: 'واچر را دریافت کنید', desc: 'پس از تأیید، واچر هتل و تأیید فروشنده به سند رزرو پیوست می‌شوند.' },
      ],
    },
    modes: {
      lead: 'نشان آنی / درخواستی روی هر نتیجه به اپراتور می‌گوید رزرو چگونه تأیید خواهد شد و چه زمانی پول جابه‌جا می‌شود.',
      modes: [
        { name: 'Instant', when: 'موجودی خودی یا تأمین‌کننده متصل با موجودی بی‌درنگ', desc: 'رزرو با کلیک تأیید می‌شود. پرداخت بی‌درنگ دریافت می‌شود. واچر بلافاصله پس از آن صادر می‌شود. سهمیه در همان لحظه کم می‌شود.' },
        { name: 'On-Request', when: 'تأمین‌کننده خارجی بدون موجودی بی‌درنگ، یا استعلام خارج از سهمیه', desc: 'رزرو به‌عنوان یک درخواست در انتظار نگه داشته می‌شود تا اپراتور (یا تأمین‌کننده) بپذیرد. تا زمان تأیید چیزی از سهمیه کم نمی‌شود؛ پرداخت در زمان تأیید دریافت می‌شود، نه در زمان درخواست.' },
        { name: 'Own inventory', when: 'آژانس قراردادهای مستقیم دارد', desc: 'اتاق‌ها از ماژول اقامتگاه هتل پلتفرم تأمین می‌شوند. سهمیه، طرح‌های نرخ و سیاست‌های لغو توسط خودِ آژانس مدیریت می‌شوند.' },
        { name: 'Connected supply', when: 'خوراک تأمین‌کننده خارجی', desc: 'اتاق‌ها از یک API شریک (بستربانک، تجمیع‌کننده) می‌آیند. سیاست‌ها + جریان استرداد از قرارداد تأمین‌کننده پیروی می‌کنند، نه آژانس.' },
      ],
    },
    examples: [
      {
        title: 'یک اقامت ۳ شبه · ۱ اتاق · ۲ مهمان · نیم‌پانسیون · آنی',
        rows: [
          { label: 'نرخ شبانه × ۳ شب', value: '9,000,000' },
          { label: 'Wholesale MARKUP · +۳٪ (حاشیه تأمین‌کننده)', value: '+270,000', accent: 'info' },
          { label: 'Retail MARKUP · +۶٪ از ناخالص', value: '+556,200', accent: 'success' },
          { label: 'مجموع مسافر', value: '9,826,200', strong: true },
        ],
        note: 'آنی بلافاصله تأیید می‌شود؛ سهمیه روی طرح نرخ برای هر یک از ۳ شب به میزان ۱ اتاق-شب کاهش می‌یابد.',
      },
      {
        title: 'همان اقامت · درخواستی',
        rows: [
          { label: 'مجموع نرخ‌گذاری‌شده (نگه‌داشته، شارژنشده)', value: '9,826,200' },
          { label: 'در صورت تأیید', value: 'پرداخت دریافت شد', accent: 'success' },
          { label: 'در صورت رد', value: 'چیزی شارژ نشد', accent: 'info' },
        ],
        note: 'نرخ‌های درخواستی قیمت را برای پنجره SLA قفل می‌کنند. اگر تأمین‌کننده نتواند درون آن پنجره تأیید کند، درخواست به‌طور خودکار منقضی می‌شود.',
      },
    ],
    related: ['tours', 'markup', 'reference-data'],
  },

  tours: {
    title: 'تورها',
    tag: 'بسته‌های تور',
    tagline: 'بسته‌های چندسرویسه قابل رزرو — هتل + پرواز + فعالیت‌ها — که به‌صورت یک سطر واحد فروخته می‌شوند.',
    business: {
      lead: 'تورها یک بسته (هتل + پرواز + ترانسفرها، وعده‌های غذایی و فعالیت‌های اختیاری) را به یک محصول قابل فروش واحد تبدیل می‌کنند. ارزش تجاری، حاشیه بسته‌بندی‌شده است: اپراتور می‌تواند بسته را برای یک کریدور مشخص از تقاضا (تیم‌های سازمانی، زیارت‌ها، تعطیلات خانوادگی) قیمت‌گذاری کند بدون آنکه کرایه‌های هر جزء را به‌صورت جداگانه افشا کند.',
      points: [
        { title: 'یک SKU، چندین جزء', desc: 'یک بسته تور یک سند رزرو واحد است حتی اگر پروازها، اتاق‌ها و سرویس‌ها را به هم بدوزد؛ این نسبت‌دهی درآمد و لغو را نسبت به فروش جداگانه اجزا تمیزتر می‌کند.' },
        { title: 'حرکت‌ها و موجودی', desc: 'یک بسته در تاریخ‌های حرکت مشخص با سقف ثابت ارائه می‌شود؛ تاریخ‌های تکمیل‌شده به‌طور خودکار از نتایج حذف می‌شوند.' },
        { title: 'همان موتور قیمت‌گذاری', desc: 'قیمت‌گذاری لایه‌ای همچنان اعمال می‌شود — یک تور از قاعده لایه‌های Wholesale / Distribution / Retail مستثنا نیست.' },
      ],
    },
    software: {
      lead: 'یک صفحه جست‌وجوی بسته که با کاتالوگ تور پشتیبانی می‌شود، با فیلترهای تاریخ حرکت و موارد شامل.',
      points: [
        { title: 'یک بسته پیدا کنید', desc: 'مقصد، پنجره حرکت و تعداد مسافران نتایج را هدایت می‌کنند؛ فیلترهای دسته و موارد شامل بیشتر محدود می‌کنند.' },
        { title: 'بسته را بررسی کنید', desc: 'انتخاب یک بسته برنامه سفر کامل و فهرست موارد شامل آن را پیش از تعهد به یک تاریخ حرکت باز می‌کند.' },
        { title: 'روی یک حرکت رزرو کنید', desc: 'یک تاریخ انتخاب کنید، مسافران را از طریق کشوی ثبت تور ثبت کنید و پرداخت را کامل کنید — نتیجه یک رزرو تور است، نه یکی به‌ازای هر جزء.' },
      ],
    },
    flow: {
      lead: 'از «می‌خواهیم در اکتبر به گرجستان سفر کنیم» تا یک بسته تأییدشده روی یک حرکت مشخص.',
      steps: [
        { title: 'سفر را وارد کنید', desc: 'کشور / منطقه مقصد، ماه حرکت، تعداد بزرگسال / کودک / نوزاد.' },
        { title: 'نتایج را مرور کنید', desc: 'کارت‌ها عنوان بسته، مدت، موارد شامل شاخص و قیمت شروع‌از برای ارزان‌ترین حرکت را نشان می‌دهند.' },
        { title: 'بسته را باز کنید', desc: 'صفحه جزئیات برنامه سفر روز به روز، موارد شامل، موارد مستثنا، اجزای هتل + پرواز و سیاست لغو را نشان می‌دهد.' },
        { title: 'یک حرکت انتخاب کنید', desc: 'تقویم حرکت تاریخ‌های موجود را با قیمت هر تاریخ و صندلی‌های باقی‌مانده نشان می‌دهد؛ تاریخ‌های تکمیل‌شده کم‌رنگ هستند.' },
        { title: 'مسافران را ثبت کنید', desc: 'کشوی ثبت تور مدرک، وعده غذایی، ترجیح هم‌اتاقی و هرگونه انتخاب فعالیت هر مسافر را جمع‌آوری می‌کند.' },
        { title: 'پرداخت و تأیید', desc: 'یک پرداخت بسته را می‌بندد. تمام واچرهای اجزا (پرواز، هتل، فعالیت‌ها) به رزرو تور واحد پیوست می‌شوند.' },
      ],
    },
    modes: {
      lead: 'تورها در امتداد دو محور عمود بر هم کاتالوگ‌بندی می‌شوند — طول سفر و مدل حرکت.',
      modes: [
        { name: 'Fixed departure', when: 'تور گروهی با تاریخ و سقف ثابت', desc: 'کل گروه در تاریخ‌های از پیش تعیین‌شده با هم پرواز و اقامت می‌کنند. حرکت‌ها تا زمانی که سقف پر شود تکمیل شده و سپس بسته می‌شوند.' },
        { name: 'Private / on-demand', when: 'مسافر مستقل که تاریخ‌های خودش را می‌خواهد', desc: 'چارچوب بسته (هتل‌ها، ترانسفرها، فعالیت‌ها) دوباره استفاده می‌شود اما پروازها و برنامه سفر به تاریخ‌های مسافر جابه‌جا می‌شوند.' },
        { name: 'Land-only', when: 'پرواز جای دیگری رزرو می‌شود', desc: 'هتل + ترانسفرها + فعالیت‌ها بدون جزء پرواز — با قیمت پایین‌تر و مسافر بلیت خودش را می‌آورد.' },
        { name: 'Full package', when: 'پیش‌فرض', desc: 'پرواز + هتل + ترانسفرها + فعالیت‌ها به‌عنوان یک قیمت. بالاترین حاشیه به‌ازای هر رزرو، ساده‌ترین برای فروش به مسافر بار اول.' },
      ],
    },
    examples: [
      {
        title: 'بسته ۵ روزه گرجستان · ۲ بزرگسال · بسته کامل',
        rows: [
          { label: 'جزء پرواز (۲ مسافر)', value: '12,000,000' },
          { label: 'جزء هتل (۴ شب × ۲ مسافر)', value: '18,000,000' },
          { label: 'ترانسفرها + فعالیت‌ها', value: '5,000,000' },
          { label: 'هزینه پایه بسته', value: '35,000,000' },
          { label: 'Wholesale MARKUP · +۵٪', value: '+1,750,000', accent: 'info' },
          { label: 'Retail MARKUP · +۸٪ از ناخالص', value: '+2,940,000', accent: 'success' },
          { label: 'مجموع مسافر', value: '39,690,000', strong: true },
        ],
        note: 'یک هزینه بسته کرایه اجزا را از مشتری پنهان می‌کند — اپراتور به‌جای دفاع از سه سطر جداگانه، یک قیمت شاخص را بازاریابی می‌کند.',
      },
    ],
    related: ['hotels-search', 'flights-search', 'markup'],
  },

  'trains-search': {
    title: 'قطارها',
    tag: 'جست‌وجوی ریلی',
    tagline: 'جست‌وجو و رزرو برای سفرهای ریلی در میان اپراتورهای ریلی متصل.',
    business: {
      lead: 'قطارها ریل را به‌عنوان جایگزین یا مکمل پرواز در کریدورهای داخلی و کوتاه‌برد می‌فروشند. شکل تجاری ریل با هوا متفاوت است (ایستگاه به ایستگاه، مبتنی بر کلاس نه مبتنی بر کابین، قوانین لغو سخت‌گیرانه‌تر) و صفحه این تفاوت‌ها را صریح می‌کند تا مأموری که یک سفر را نرخ‌گذاری می‌کند محصول درست را برای طول سفر انتخاب کند.',
      points: [
        { title: 'ریتم قیمت‌گذاری متفاوت', desc: 'کرایه‌های ریلی مانند پروازها دقیقه‌به‌دقیقه نوسان نمی‌کنند؛ جدول‌های زمانی ثابت به این معناست که همان کرایه اغلب برای ساعت‌ها در دسترس است، پس نرخ‌ها پایدارترند.' },
        { title: 'کلاس بیش از خط هوایی اهمیت دارد', desc: 'انتخاب میان کلاس اقتصادی / درجه‌یک / بیزنس روی همان قطار است، نه میان حامل‌های رقیب — محور تصمیم خریدار متفاوت است.' },
        { title: 'بلیت رزروشده در برابر آزاد', desc: 'برخی مسیرها به رزرو صندلی نیاز دارند، برخی دیگر بلیت آزاد می‌پذیرند؛ جریان بر اساس هر اپراتور تطبیق می‌یابد.' },
      ],
    },
    software: {
      lead: 'یک جست‌وجوی ایستگاه به ایستگاه با فیلترهای سفر / کلاس / اپراتور.',
      points: [
        { title: 'سفر را بسازید', desc: 'ایستگاه‌های مبدأ و مقصد، تاریخ حرکت و تعداد مسافر جست‌وجو را هدایت می‌کنند.' },
        { title: 'سطر سفر را بخوانید', desc: 'هر نتیجه اپراتور، گزینه‌های کلاس و کرایه هر کلاس را نشان می‌دهد؛ زمان عبور و توقف‌ها روی سطر هستند.' },
        { title: 'به سمت رزرو پیش بروید', desc: 'انتخاب یک کرایه جریان فرم مسافر / انتخاب صندلی را باز می‌کند، سپس پرداخت؛ رزرو حاصل مانند هر رزرو دیگری رفتار می‌کند.' },
      ],
    },
    flow: {
      lead: 'یک رزرو ریلی اجزای متحرک کمتری نسبت به پرواز دارد — اما رزرو صندلی و انتخاب کلاس جایگزین انتخاب کابین می‌شوند.',
      steps: [
        { title: 'ایستگاه‌ها را انتخاب کنید', desc: 'ایستگاه‌های مبدأ و مقصد (نه شهرها — یک شهر می‌تواند چند ایستگاه داشته باشد و انتخاب درست، یک تاکسی برای مسافر صرفه‌جویی می‌کند).' },
        { title: 'تاریخ را انتخاب کنید', desc: 'ریل از نظر قیمت بسیار کمتر از هوا به تاریخ حساس است؛ همان کرایه معمولاً برای کل روز عملیاتی نگه داشته می‌شود.' },
        { title: 'فهرست سفرها را بخوانید', desc: 'حرکت‌های روز با مدت، توقف‌ها، گزینه‌های کلاس و قیمت هر کلاس فهرست می‌شوند.' },
        { title: 'یک کلاس انتخاب کنید', desc: 'اقتصادی، درجه‌یک یا بیزنس، راحتی صندلی و (روی برخی اپراتورها) وعده غذایی / دسترسی به لانژ را تغییر می‌دهند.' },
        { title: 'یک صندلی رزرو کنید', desc: 'روی اپراتورهایی که به رزرو نیاز دارند، انتخابگر نقشه صندلی پس از انتخاب کلاس باز می‌شود؛ اپراتورهای بلیت آزاد این مرحله را رد می‌کنند.' },
        { title: 'ثبت مسافران + پرداخت', desc: 'فرم مسافر استاندارد + پرداخت؛ بلیت الکترونیکی / QR به رزرو پیوست می‌شود.' },
      ],
    },
    modes: {
      lead: 'کرایه‌های ریلی در دو محور از هوا واگرا می‌شوند — اینکه بلیت به یک صندلی مشخص گره خورده باشد، و اینکه کلاس واقعاً چه چیزی برای شما می‌خرد.',
      modes: [
        { name: 'Reserved seat', when: 'اپراتورهای پرسرعت / دوربرد', desc: 'بلیت به یک قطار و صندلی مشخص مقید است. از قطار جا بمانید و بلیت باطل می‌شود (یا مشمول هزینه تغییر رزرو). نقشه صندلی هنگام رزرو در دسترس است.' },
        { name: 'Open ticket', when: 'مسیرهای حومه‌ای / کوتاه‌برد', desc: 'روی هر قطار از یک کلاس درون یک پنجره اعتبار (معمولاً روز سفر) معتبر است. بدون نقشه صندلی — به ترتیب ورود در واگن آن کلاس.' },
        { name: 'Economy class', when: 'نقطه قیمت پیش‌فرض', desc: 'صندلی استاندارد، بدون موارد شامل اضافی. عمده رزروهای ریلی.' },
        { name: 'First class', when: 'مسافران کاری', desc: 'فاصله صندلی بیشتر، واگن آرام‌تر، گاهی یک وعده سبک یا دسترسی به لانژ.' },
        { name: 'Business class', when: 'دوربرد پریمیوم', desc: 'فقط روی برخی اپراتورها. صندلی همراه با میز، برق شهری، سوار شدن اولویت‌دار، سرویس کامل غذا.' },
      ],
    },
    examples: [
      {
        title: 'تهران → مشهد · شبانه · درجه‌یک · ۲ مسافر',
        rows: [
          { label: 'کرایه پایه (به‌ازای هر مسافر) × ۲', value: '3,200,000' },
          { label: 'Retail MARKUP · +۵٪', value: '+160,000', accent: 'success' },
          { label: 'مجموع مسافر', value: '3,360,000', strong: true },
        ],
        note: 'ریل معمولاً لایه Wholesale را دور می‌زند — اپراتور با کرایه منتشرشده می‌فروشد و تنها حاشیه آژانس، Retail است.',
      },
    ],
    related: ['buses-search', 'flights-search', 'markup'],
  },

  'buses-search': {
    title: 'اتوبوس‌ها',
    tag: 'جست‌وجوی اتوبوس',
    tagline: 'مسیرهای اتوبوس بین‌شهری برای کریدورهایی که حمل‌ونقل جاده‌ای در قیمت یا دسترسی برنده است.',
    business: {
      lead: 'اتوبوس‌ها کریدورهایی را پوشش می‌دهند که در آن‌ها اتوبوس یا تنها گزینه واقع‌بینانه است یا آشکارا از هوا / ریل ارزان‌تر است. نقش تجاری آن پوشش است: به آژانس اجازه می‌دهد یک سفر کامل سرتاسری را برای مشتری‌ای رزرو کند که مسیرش شهرهای بدون فرودگاه یا ایستگاه ریلی را لمس می‌کند.',
      points: [
        { title: 'پوشش بر سرعت', desc: 'اتوبوس‌ها به شهرها و شهرک‌هایی می‌رسند که پروازها و ریل نمی‌رسند — حیاتی برای زیارت، سفرهای کاری منطقه‌ای و اتصالات آخرین‌مایل.' },
        { title: 'کرایه‌های ساده و نقدی‌پسند', desc: 'کرایه‌های اتوبوس معمولاً به‌ازای هر صندلی ثابت با کلاس‌های برند کمتر هستند، که نرخ‌گذاری عمده / سازمانی را سرراست می‌کند.' },
        { title: 'اجزای متحرک تأمین‌کننده کمتر', desc: 'بیشتر اپراتورها به‌جای موجودی پویا یک جدول زمانی ثابت ارائه می‌دهند، پس نتایج جست‌وجو در طول یک روز پایدار هستند.' },
      ],
    },
    software: {
      lead: 'یک جست‌وجوی شهر به شهر با فیلترهای اپراتور / کلاس صندلی، که در حال حاضر تا یکپارچه‌سازی بک‌اند متوقف شده است.',
      points: [
        { title: 'سفر را بسازید', desc: 'شهرهای مبدأ و مقصد، تاریخ حرکت و تعداد مسافر جست‌وجو را هدایت می‌کنند.' },
        { title: 'سطر مسیر را بخوانید', desc: 'هر نتیجه اپراتور، مدت و قیمت را نشان می‌دهد؛ گزینه‌های کلاس صندلی هنگام انتخاب باز می‌شوند.' },
        { title: 'به سمت رزرو پیش بروید', desc: 'یک صندلی انتخاب‌شده جریان مسافر و پرداخت را باز می‌کند؛ سند مانند هر محصول دیگری به همه رزروها می‌پیوندد.' },
      ],
    },
    flow: {
      lead: 'رزرو یک اتوبوس ساده‌ترین جریان حمل‌ونقل است — یک جدول زمانی ثابت، یک کلاس صندلی واحد در هر مسیر (معمولاً)، و یک کرایه ثابت به‌ازای هر صندلی.',
      steps: [
        { title: 'مبدأ + مقصد را انتخاب کنید', desc: 'شهرها (نه ایستگاه‌ها — اپراتور معمولاً یک پایانه در هر شهر دارد).' },
        { title: 'تاریخ را انتخاب کنید', desc: 'جدول زمانی کامل روز بارگذاری می‌شود — کرایه‌ها در طول روز نوسان نمی‌کنند.' },
        { title: 'یک حرکت انتخاب کنید', desc: 'هر سطر یک حرکت است: اپراتور، کلاس صندلی، قیمت و زمان تخمینی سفر.' },
        { title: 'یک صندلی انتخاب کنید', desc: 'روی اپراتورهایی که پشتیبانی می‌کنند یک نقشه صندلی باز می‌شود؛ در غیر این صورت بلیت هنگام سوار شدن اختصاص می‌یابد.' },
        { title: 'ثبت مسافران + پرداخت', desc: 'فرم مسافر استاندارد + پرداخت؛ QR / بلیت الکترونیکی به رزرو پیوست می‌شود.' },
      ],
    },
    modes: {
      lead: 'اپراتورهای اتوبوس بیشتر یک کلاس سرویس ارائه می‌دهند، اما تجربه انتخاب صندلی متفاوت است.',
      modes: [
        { name: 'Assigned seat', when: 'اپراتورهایی با نقشه صندلی', desc: 'هنگام رزرو یک صندلی مشخص انتخاب کنید. بلیت الکترونیکی شماره صندلی را حمل می‌کند و اپراتور سوار کننده آن را اعمال می‌کند.' },
        { name: 'Open seating', when: 'اپراتورهایی بدون نقشه صندلی', desc: 'صندلی هنگام سوار شدن گرفته می‌شود. بلیت الکترونیکی فقط یک جای روی آن حرکت را تضمین می‌کند.' },
        { name: 'VIP class', when: 'مسیرهای دوربرد پریمیوم', desc: 'صندلی‌های پهن‌تر، گاهی چیدمان ۳-تایی (۲+۱) به‌جای استاندارد ۲+۲، روی برخی اپراتورها شامل پذیرایی سبک.' },
        { name: 'Standard class', when: 'پیش‌فرض', desc: 'صندلی استاندارد اتوبوس، بدون موارد شامل اضافی. ارزان‌ترین و رایج‌ترین.' },
      ],
    },
    examples: [
      {
        title: 'تهران → اصفهان · کلاس VIP · ۲ مسافر',
        rows: [
          { label: 'کرایه پایه (به‌ازای هر مسافر) × ۲', value: '1,600,000' },
          { label: 'Retail MARKUP · +۶٪', value: '+96,000', accent: 'success' },
          { label: 'مجموع مسافر', value: '1,696,000', strong: true },
        ],
        note: 'اتوبوس محصولی با حاشیه نازک است — قیمت‌گذاری فقط-Retail هنجار است؛ اپراتور کرایه را منتشر می‌کند و سهم آژانس در Retail افزوده می‌شود.',
      },
    ],
    related: ['trains-search', 'ground', 'markup'],
  },

  // ── Flights funnel (search → results → passengers → seats → payment → ticket, + manual) ──
  'flights-results': {
    title: 'نتایج پرواز',
    tag: 'جست‌وجوی پرواز',
    tagline: 'هر کرایه قابل صدور برای سفر، ادغام و رتبه‌بندی‌شده — آن را که می‌خواهید بلیت کنید انتخاب کنید.',
    business: {
      lead: 'صفحه نتایج جایی است که یک نرخ‌گذاری به یک انتخاب تبدیل می‌شود. هر سطر کرایه‌ای است که آژانس واقعاً می‌تواند صادر کند (SIGN خودی یا یک SIGN شریک)، قیمت نمایش‌داده‌شده از پیش مارک‌آپ‌های Wholesale / Distribution / Retail را حمل می‌کند، و SIGN صادرکننده دیده می‌شود تا مأمور پیش از تعهد بداند بلیت چگونه اجرا خواهد شد.',
      points: [
        { title: 'یک فهرست ادغام‌شده و رتبه‌بندی‌شده', desc: 'کرایه‌ها از هر تأمین‌کننده فعال ترکیب و بر اساس قیمت رتبه‌بندی می‌شوند، پس مأمور به‌جای پرش میان زبانه‌ها، مشابه با مشابه مقایسه می‌کند.' },
        { title: 'قیمت همه‌شمول است', desc: 'آنچه روی سطر نشان داده می‌شود همان چیزی است که مسافر می‌پردازد — لایه‌های موتور قیمت‌گذاری از پیش اعمال شده‌اند.' },
        { title: 'مقایسه بر اساس آنچه اهمیت دارد', desc: 'بار، قابلیت استرداد، توقف‌ها و زمان پرواز به همان اندازه قیمت شاخص تصمیم را هدایت می‌کنند.' },
      ],
    },
    software: {
      lead: 'یک فهرست کرایه قابل فیلتر و مرتب‌سازی با یک نوار کرایه ارزان‌ترین-بر-اساس-تاریخ.',
      points: [
        { title: 'فیلتر و مرتب‌سازی', desc: 'نوار کناری با توقف‌ها، بازه قیمت، خطوط هوایی، زمان حرکت / رسیدن، نوع کرایه و منبع محدود می‌کند.' },
        { title: 'نوار کرایه را مرور کنید', desc: 'یک تقویم کوچک ارزان‌ترین کرایه هر تاریخ ±۷ روز را نشان می‌دهد؛ روی یک تاریخ کلیک کنید تا جست‌وجو دوباره اجرا شود.' },
        { title: 'سطر را بخوانید، سپس انتخاب کنید', desc: 'هر کارت برنامه سفر مقاطع، برچسب‌های بار و (در جست‌وجو و رزرو) خالص / حاشیه / کمیسیون را نشان می‌دهد؛ انتخاب یک کرایه تقسیم به‌ازای هر مسافر آن را به مرحله مسافر می‌برد.' },
      ],
    },
    related: ['flights-search', 'flights-passengers', 'markup'],
  },

  'flights-manual': {
    title: 'ورود دستی پرواز',
    tag: 'بلیت خارج از کانال',
    tagline: 'یک پرواز رزروشده خارج از پلتفرم را ثبت کنید تا مانند هر رزرو دیگری در دفتر سفارش باشد.',
    business: {
      lead: 'هر بلیتی از قیف جست‌وجو نمی‌آید — برخی مستقیماً با یک خط هوایی، از طریق یک تجمیع‌کننده یا تلفنی صادر می‌شوند. ورود دستی آن‌ها را ثبت می‌کند تا رزرو، مسافرانش و پولش در کنار فروش‌های آنلاین ردیابی، فاکتور و گزارش شوند.',
      points: [
        { title: 'یک دفتر سفارش', desc: 'هیچ چیز فروخته‌شده خارج از سیستم نامرئی نمی‌ماند — یک بلیت دستی مانند هر سفارش دیگری به همه رزروها می‌پیوندد.' },
        { title: 'حاشیه همچنان گزارش می‌شود', desc: 'تفکیک کامل کرایه (پایه، مالیات‌ها، هزینه‌ها، مارک‌آپ، کمیسیون) ثبت می‌شود، پس گزارش سود کامل می‌ماند.' },
        { title: 'پشتیبانی از چند مقطع', desc: 'برنامه‌های سفر یک‌طرفه، رفت‌وبرگشت و چندشهری همگی قابل کلید زدن هستند، با یک بلیت الکترونیکی به‌ازای هر مسافر در هر مقطع.' },
      ],
    },
    software: {
      lead: 'یک فرم ساختاریافته برای کلید زدن برنامه سفر، تأمین‌کننده و بلیت‌های الکترونیکی هر مسافر.',
      points: [
        { title: 'برنامه سفر را بسازید', desc: 'نوع سفر به‌علاوه کارت‌های مقطع — فرودگاه‌های مبدأ / مقصد، خط هوایی، زمان‌ها، هواپیما، کابین و صندلی.' },
        { title: 'منبع و پول را تنظیم کنید', desc: 'منبع رزرو / تأمین‌کننده، کد تور و ارز، با تفکیک کرایه هر مقطع.' },
        { title: 'بلیت‌ها را اختصاص دهید، سپس ادامه دهید', desc: 'یک بلیت الکترونیکی به‌ازای هر مسافر به مقاطع اختصاص می‌یابد؛ به مرحله مسافر ادامه دهید.' },
      ],
    },
    related: ['flights-search', 'flights-passengers', 'bookings'],
  },

  'flights-passengers': {
    title: 'مسافران پرواز',
    tag: 'جزئیات مسافر',
    tagline: 'هر مسافر را نام ببرید، رده کرایه را انتخاب کنید و جزئیاتی را که خط هوایی برای صدور نیاز دارد ثبت کنید.',
    business: {
      lead: 'مرحله مسافر جایی است که یک پیشنهاد به یک رزرو نام‌گذاری‌شده و قابل صدور تبدیل می‌شود. مدرک و جزئیات تماس واردشده اینجا همان چیزهایی هستند که خط هوایی هنگام صدور و مرز هنگام سفر بررسی می‌کند — درست انجام دادن آن در بار اول از صدور مجدد پرهزینه جلوگیری می‌کند.',
      points: [
        { title: 'رده کرایه یک انتخاب تجاری است', desc: 'Saver / Flex / Plus قیمت را در برابر بار، قابلیت استرداد، صندلی و وعده غذایی مبادله می‌کنند — مأمور رده متناسب با مسافر را انتخاب می‌کند.' },
        { title: 'داده پاسپورت الزامی است', desc: 'نام، تاریخ تولد، ملیت، شماره پاسپورت و انقضا ورودی‌های صدور خط هوایی هستند، نه افزودنی‌های اختیاری.' },
        { title: 'پیش‌پرکردن CRM از فشار کلید صرفه‌جویی می‌کند', desc: 'انتخاب یک مشتری ذخیره‌شده مسافرانش را از CRM پیش‌پر می‌کند، پس یک مسافر بازگشتی یک بار وارد و دوباره استفاده می‌شود.' },
      ],
    },
    software: {
      lead: 'یک شبکه رده کرایه به‌علاوه یک کارت هویت به‌ازای هر مسافر و یک بلوک تماس سرتاسر سفر.',
      points: [
        { title: 'رده کرایه را انتخاب کنید', desc: 'یک شبکه رده‌ها را بر اساس بار، استرداد، صندلی، وعده غذایی و کسب مسافر مکرر مقایسه می‌کند.' },
        { title: 'هر کارت مسافر را پر کنید', desc: 'عنوان، نام، تاریخ تولد، ملیت، شماره مسافر مکرر، پاسپورت و انقضا، به‌علاوه برچسب‌های SSR وعده غذایی / صندلی.' },
        { title: 'تماس را اضافه کنید، سپس ادامه دهید', desc: 'ایمیل و تلفن با کد شماره‌گیری برای رزرو؛ به انتخاب صندلی اختیاری یا مستقیم به پرداخت ادامه دهید.' },
      ],
    },
    related: ['flights-results', 'flights-seats', 'flights-payment', 'customers'],
  },

  'flights-seats': {
    title: 'انتخاب صندلی',
    tag: 'افزودنی اختیاری',
    tagline: 'صندلی‌ها را روی یک نقشه تعاملی اختصاص دهید — یا رد کنید و بگذارید خط هوایی تخصیص دهد.',
    business: {
      lead: 'انتخاب صندلی یک افزودنی اختیاری و اغلب پولی است. انتخاب صندلی از پیش تجربه مسافر را بهبود می‌دهد و جایی که نقشه پولی است می‌تواند حاشیه بیفزاید؛ رد کردن، تخصیص را در زمان پذیرش بدون هزینه به خط هوایی می‌سپارد. در هر صورت رزرو پیش می‌رود.',
      points: [
        { title: 'همیشه اختیاری', desc: 'رد کنید و خط هوایی صندلی‌ها را هنگام پذیرش تخصیص می‌دهد — رزرو هرگز روی این مرحله مسدود نمی‌شود.' },
        { title: 'پولی در برابر رایگان متفاوت است', desc: 'صندلی‌های استاندارد، ترجیحی و فضای پای اضافی بسته به کرایه و حامل می‌توانند هزینه‌های متفاوتی داشته باشند.' },
        { title: 'به‌ازای هر مسافر', desc: 'به هر مسافر روی رزرو صندلی خودش اختصاص می‌یابد.' },
      ],
    },
    software: {
      lead: 'یک نقشه صندلی که برای هواپیما ترسیم شده، با یک نوار کناری مسافر و یک شمارش در حال اجرای تخصیص.',
      points: [
        { title: 'نقشه را بخوانید', desc: 'شبکه صندلی‌های موجود، اشغال‌شده و انتخاب‌شده را برای چیدمان هواپیما نشان می‌دهد.' },
        { title: 'به هر مسافر اختصاص دهید', desc: 'از نوار کناری برای هر مسافر یک صندلی انتخاب کنید؛ پاورقی ردیابی می‌کند چند نفر تخصیص یافته‌اند.' },
        { title: 'رد کنید یا ادامه دهید', desc: 'تخصیص‌ها را ذخیره کنید یا رد کنید؛ هر دو به پرداخت پیش می‌روند. (همان نقشه صندلی به اتوبوس‌ها هم سرویس می‌دهد.)' },
      ],
    },
    related: ['flights-passengers', 'flights-payment'],
  },

  'flights-payment': {
    title: 'پرداخت پرواز',
    tag: 'دریافت و صدور',
    tagline: 'انتخاب کنید رزرو چگونه پرداخت شود، سپس بلیت را صادر کنید.',
    business: {
      lead: 'پرداخت جایی است که پول متعهد و بلیت صادر می‌شود. روش تصمیم می‌گیرد که وجوه چگونه جابه‌جا شوند — بی‌درنگ از کیف پول یا خط اعتباری آژانس، یا از طریق کارت / درگاه / POS / انتقال بانکی که مأمور ثبت می‌کند — و خلاصه سفارش پیش از تعهد، حاشیه و کمیسیون مأمور را نشان می‌دهد.',
      points: [
        { title: 'کیف پول و اعتبار آنی هستند', desc: 'هر دو بر پایه حساب آژانس برداشت می‌کنند، پس بلیت می‌تواند بدون انتظار برای یک مجرای خارجی صادر شود.' },
        { title: 'پشتیبانی از مجراهای ایرانی', desc: 'IPG (شاپرک / زرین‌پال و نظایر آن)، کارت‌خوان POS، انتقال بانکی شبا و کارت 3DS همگی روش‌های درجه‌یک هستند.' },
        { title: 'حاشیه پیش از صدور دیده می‌شود', desc: 'در جست‌وجو و رزرو، خلاصه خالص / مارک‌آپ / کمیسیون را نشان می‌دهد تا مأمور با چشمان باز متعهد شود.' },
      ],
    },
    software: {
      lead: 'یک انتخابگر روش پرداخت با فیلدهای مخصوص روش و یک نوار کناری خلاصه سفارش.',
      points: [
        { title: 'روش را انتخاب کنید', desc: 'کیف پول، خط اعتباری، کارت مشتری، نقد، IPG، POS یا انتقال بانکی — هر کدام یک کارت رادیویی است.' },
        { title: 'فرم روش را پر کنید', desc: 'کارت 3DS؛ درگاه IPG + تلفن + مرجع؛ پایانه POS / RRN / پیگیری؛ شبا مبدأ و مقصد IBAN + مرجع.' },
        { title: 'فاکتور را اضافه کنید، سپس صادر کنید', desc: 'جزئیات صورت‌حساب، VAT و PO روی بلوک فاکتور؛ «پرداخت و صدور» سفارش را ایجاد و به بلیت حرکت می‌کند.' },
      ],
    },
    modes: {
      lead: 'همان روش‌های پرداخت در همه محصولات در دسترس هستند — انتخاب درباره چگونگی و زمان تسویه پول است.',
      modes: [
        { name: 'Wallet', when: 'پیش‌فرض / توصیه‌شده', desc: 'در زمان واقعی از موجودی پیش‌پرداخت آژانس بدهکار می‌شود. سریع‌ترین مسیر به صدور؛ بدون مرحله خارجی.' },
        { name: 'Credit line', when: 'آژانس سقف اعتباری دارد', desc: 'بر پایه اعتبار کوتاه‌مدت آژانس برداشت می‌شود؛ بعداً طبق شرایط اعتبار تسویه می‌شود.' },
        { name: 'IPG link', when: 'مشتری آنلاین پرداخت می‌کند', desc: 'یک لینک پرداخت از طریق یک درگاه ایرانی (شاپرک / زرین‌پال / آیدی‌پی…) برای مشتری ارسال می‌شود؛ مرجع درگاه هنگام بازگشت ثبت می‌شود.' },
        { name: 'POS', when: 'کارت حاضر روی پیشخوان', desc: 'روی کارت‌خوان شعبه دریافت می‌شود؛ شناسه پایانه، RRN و شماره پیگیری به‌عنوان اثبات کلید زده می‌شوند.' },
        { name: 'Bank transfer (Sheba)', when: 'واریز مستقیم IBAN', desc: 'شبا مبدأ و مقصد IBAN به‌علاوه مرجع انتقال برای تسویه ثبت می‌شوند.' },
      ],
    },
    related: ['flights-passengers', 'flights-ticket', 'counter', 'markup'],
  },

  'flights-ticket': {
    title: 'بلیت پرواز',
    tag: 'بلیت الکترونیکی صادرشده',
    tagline: 'بلیت الکترونیکی صادرشده — PNR، مسافر، برنامه سفر و سود مأمور از فروش.',
    business: {
      lead: 'صفحه بلیت اثبات فروش است — شماره‌های PNR و بلیت الکترونیکی که مسافر حمل می‌کند و آژانس برای هر اقدام سرویس به آن ارجاع می‌دهد. همچنین حلقه تجاری را می‌بندد و حاشیه محقق‌شده (فروش − هزینه + کمیسیون) روی رزرو را به مأمور نشان می‌دهد.',
      points: [
        { title: 'مدرک مسافر', desc: 'PNR و شماره بلیت، برنامه سفر کامل، صندلی و وضعیت رزرو در یک مکان.' },
        { title: 'سرویس‌دهی از اینجا شروع می‌شود', desc: 'برنامه سفر را ایمیل کنید، مرجع را کپی کنید، رزرو را تغییر دهید یا از اقدامات سریع یک استرداد ثبت کنید.' },
        { title: 'سود محقق می‌شود', desc: 'جمع‌بندی مالی (فروش، هزینه، مارک‌آپ، کمیسیون، سود) حاشیه این فروش را صریح می‌کند.' },
      ],
    },
    software: {
      lead: 'یک بلیت به‌سبک واچر با پرواز، مسافر و مالیات‌ها که چیده شده‌اند.',
      points: [
        { title: 'سربرگ و نوار مسافر', desc: 'PNR، برچسب بلیت الکترونیکی، نام مسافر، شماره بلیت، مسافر مکرر و زمان صدور.' },
        { title: 'شبکه برنامه سفر', desc: 'شماره پرواز، هواپیما، کابین، رده کرایه، زمان‌های حرکت / رسیدن و توقف‌ها.' },
        { title: 'مالیات‌ها و اقدامات', desc: 'یک نوار کناری حاشیه به‌علاوه کنترل‌های ایمیل / کپی / تغییر / استرداد.' },
      ],
    },
    related: ['flights-payment', 'bookings', 'booking-detail', 'refunds'],
  },

  // ── Trains funnel (search → results → seats & pax → payment → ticket, + manual) ──
  'trains-results': {
    title: 'نتایج قطار',
    tag: 'جست‌وجوی ریلی',
    tagline: 'هر حرکت روز، رتبه‌بندی‌شده — قطار و کلاسی که می‌خواهید رزرو کنید انتخاب کنید.',
    business: {
      lead: 'نتایج ریلی پایدارتر از هوا هستند: جدول زمانی روز و کرایه‌هایش نگه داشته می‌شوند، پس مأمور به‌جای دنبال کردن یک قیمت متحرک، بر اساس زمان، کلاس و قابلیت استرداد مقایسه می‌کند. هر سطر یک حرکت قابل رزرو با گزینه‌های کلاس و صندلی‌های باقی‌مانده آن است.',
      points: [
        { title: 'کرایه‌ها پایدار هستند', desc: 'همان کرایه معمولاً در طول روز عملیاتی نگه داشته می‌شود، پس یک نرخ بیش از یک کرایه پرواز معتبر می‌ماند.' },
        { title: 'مقایسه کلاس، نه حامل', desc: 'تصمیم میان انواع واگن و راحتی روی مسیر است، نه میان خطوط هوایی رقیب.' },
        { title: 'قابلیت استرداد از پیش', desc: 'هر سطر پیش از تعهد مأمور با برچسب قابل‌استرداد / جزئی / غیرقابل‌استرداد مشخص می‌شود.' },
      ],
    },
    software: {
      lead: 'یک فهرست سفر با اپراتور، زمان‌ها، نوع واگن و قیمت هر کلاس، به‌علاوه یک نوار کرایه.',
      points: [
        { title: 'روز را فیلتر کنید', desc: 'نوار کناری با مرتب‌سازی، پنهان‌کردن تکمیل‌شده‌ها، اپراتور، هیستوگرام قیمت، نوع واگن و بازه زمان روز محدود می‌کند.' },
        { title: 'نوار کرایه را مرور کنید', desc: 'یک تقویم کوچک ±۷ روز ارزان‌ترین قیمت هر تاریخ را نشان می‌دهد؛ برای جست‌وجوی مجدد کلیک کنید.' },
        { title: 'یک حرکت انتخاب کنید', desc: 'سطرها اپراتور، زمان‌ها، توقف‌ها، صندلی‌های باقی‌مانده و برچسب‌های استرداد را نشان می‌دهند؛ انتخاب به صندلی‌ها و مسافران پیش می‌رود.' },
      ],
    },
    related: ['trains-search', 'trains-passengers', 'markup'],
  },

  'trains-manual': {
    title: 'ورود دستی قطار',
    tag: 'بلیت خارج از کانال',
    tagline: 'یک بلیت ریلی رزروشده خارج از پلتفرم را در دفتر سفارش ثبت کنید.',
    business: {
      lead: 'برخی بلیت‌های ریلی مستقیماً در یک ایستگاه یا پیشخوان اپراتور خریداری می‌شوند. ورود دستی آن‌ها را به همان دفتر سفارش می‌آورد تا در کنار فروش‌های ریلی آنلاین ردیابی، فاکتور و گزارش شوند — هیچ رزروی از قلم نمی‌افتد.',
      points: [
        { title: 'یک دفتر سفارش', desc: 'یک بلیت ریلی خارج از کانال مانند هر سفارش دیگری به همه رزروها می‌پیوندد.' },
        { title: 'حاشیه همچنان گزارش می‌شود', desc: 'تفکیک کرایه ثبت می‌شود تا گزارش سود کامل بماند.' },
        { title: 'برنامه سفر در سطح ایستگاه', desc: 'مقاطع بر اساس ایستگاه کلید زده می‌شوند، مطابق با نحوه فروش واقعی ریل.' },
      ],
    },
    software: {
      lead: 'فرم مشترک ورود دستی حمل‌ونقل، که برای ریل کلید زده شده است.',
      points: [
        { title: 'سفر را کلید بزنید', desc: 'مقاطع با ایستگاه‌ها، اپراتور، زمان‌ها و کلاس.' },
        { title: 'منبع و پول را تنظیم کنید', desc: 'تأمین‌کننده، ارز و یک تفکیک کرایه هر مقطع.' },
        { title: 'بلیت‌ها را اختصاص دهید، سپس ادامه دهید', desc: 'یک بلیت به‌ازای هر مسافر؛ به مرحله مسافر ادامه دهید.' },
      ],
    },
    related: ['trains-search', 'trains-passengers', 'bookings'],
  },

  'trains-passengers': {
    title: 'صندلی‌ها و مسافران قطار',
    tag: 'کلاس، صندلی و مسافر',
    tagline: 'کلاس را انتخاب کنید، صندلی‌های واگن را روی نقشه انتخاب کنید و مسافران را نام ببرید.',
    business: {
      lead: 'ریل انتخاب کلاس و نقشه صندلی را در یک مرحله تا می‌کند. کلاس راحتی و موارد شامل را تعیین می‌کند؛ نقشه واگن / صندلی بلیت را به یک جای فیزیکی مقید می‌کند (بسیاری از اپراتورها کوپه‌های مبتنی بر جنسیت را اعمال می‌کنند)؛ و جزئیات مسافر رزرو را کامل می‌کند.',
      points: [
        { title: 'کلاس اهرم است', desc: 'استاندارد / ممتاز / راحتی قیمت را با مزایا مبادله می‌کنند — تصمیم اصلی مأمور روی ریل.' },
        { title: 'صندلی بلیت را مقید می‌کند', desc: 'یک واگن و صندلی روی نقشه انتخاب می‌شوند؛ رزروشده در برابر آزاد به اپراتور بستگی دارد.' },
        { title: 'فیلدهای مدرک کمتر از هوا', desc: 'ریل به نام، تماس و وفاداری نیاز دارد — نه مجموعه کامل پاسپورت / APIS که یک پرواز نیاز دارد.' },
      ],
    },
    software: {
      lead: 'یک انتخابگر کلاس، یک نقشه تعاملی واگن / صندلی و یک فرم مسافر.',
      points: [
        { title: 'کلاس را انتخاب کنید', desc: 'کارت‌ها قیمت و مزایا را به‌ازای هر کلاس سفر مقایسه می‌کنند.' },
        { title: 'واگن و صندلی را انتخاب کنید', desc: 'واگن‌ها را جابه‌جا کنید و صندلی‌ها را روی یک شبکه (موجود / اشغال‌شده / انتخاب‌شده) انتخاب کنید، با یک راهنمای امکانات.' },
        { title: 'مسافران را نام ببرید', desc: 'عنوان، نام، ایمیل، تلفن و شناسه وفاداری به‌ازای هر مسافر؛ به پرداخت ادامه دهید.' },
      ],
    },
    related: ['trains-results', 'trains-payment', 'customers'],
  },

  'trains-payment': {
    title: 'پرداخت قطار',
    tag: 'دریافت و صدور',
    tagline: 'انتخاب کنید رزرو ریلی چگونه پرداخت شود، سپس بلیت را صادر کنید — پیش از انقضای قفل صندلی.',
    business: {
      lead: 'پرداخت کرایه را متعهد و بلیت ریلی را صادر می‌کند. چون صندلی فقط برای یک پنجره قفل کوتاه پس از انتخاب نگه داشته می‌شود، کامل کردن سریع پرداخت همان چیزی است که آن را تضمین می‌کند. روش تصمیم می‌گیرد که وجوه چگونه جابه‌جا شوند — کیف پول / اعتبار به‌طور آنی، یا یک درگاه / POS / انتقال که مأمور ثبت می‌کند.',
      points: [
        { title: 'صندلی روی یک تایمر است', desc: 'انتخاب یک نگه‌داشت کوتاه می‌گذارد؛ پیش از انقضا پرداخت کنید وگرنه صندلی آزاد می‌شود.' },
        { title: 'کیف پول و اعتبار آنی هستند', desc: 'هر دو بر پایه حساب آژانس برای صدور فوری برداشت می‌کنند.' },
        { title: 'پشتیبانی از مجراهای ایرانی', desc: 'IPG، POS و انتقال بانکی شبا همگی در کنار کیف پول و اعتبار در دسترس هستند.' },
      ],
    },
    software: {
      lead: 'یک انتخابگر روش پرداخت با فیلدهای مخصوص روش و یک خلاصه پرداخت.',
      points: [
        { title: 'روش را انتخاب کنید', desc: 'کیف پول، اعتبار، کارت، IPG، POS یا انتقال شبا.' },
        { title: 'فرم روش را پر کنید', desc: 'درگاه IPG + تلفن + مرجع؛ پایانه POS / RRN / پیگیری؛ شبا مبدأ و مقصد IBAN + مرجع.' },
        { title: 'قفل را یادداشت کنید، سپس صادر کنید', desc: 'یک بنر قفل صندلی نشان می‌دهد چه چیزی نگه داشته شده؛ «پرداخت و صدور» شارژ می‌کند و به بلیت حرکت می‌کند.' },
      ],
    },
    modes: {
      lead: 'همان روش‌های پرداخت در همه محصولات در دسترس هستند — انتخاب درباره چگونگی و زمان تسویه پول است.',
      modes: [
        { name: 'Wallet', when: 'پیش‌فرض / توصیه‌شده', desc: 'در زمان واقعی از موجودی پیش‌پرداخت آژانس بدهکار می‌شود. سریع‌ترین مسیر به صدور.' },
        { name: 'Credit line', when: 'آژانس سقف اعتباری دارد', desc: 'بر پایه اعتبار کوتاه‌مدت برداشت می‌شود؛ بعداً طبق شرایط تسویه می‌شود.' },
        { name: 'IPG link', when: 'مشتری آنلاین پرداخت می‌کند', desc: 'یک لینک درگاه (شاپرک / زرین‌پال…) برای مشتری ارسال می‌شود؛ مرجع هنگام بازگشت ثبت می‌شود.' },
        { name: 'POS', when: 'کارت حاضر روی پیشخوان', desc: 'روی کارت‌خوان شعبه دریافت می‌شود؛ شناسه پایانه، RRN و پیگیری کلید زده می‌شوند.' },
        { name: 'Bank transfer (Sheba)', when: 'واریز مستقیم IBAN', desc: 'شبا مبدأ / مقصد IBAN و مرجع انتقال ثبت می‌شوند.' },
      ],
    },
    related: ['trains-passengers', 'trains-ticket', 'counter'],
  },
};
